// Dependencies
import React, { FunctionComponent } from 'react'

// Types
import { FooterProps } from './footer.types'

// Styles
import {
  AddressWrapper,
  Container,
  ContentWrapper,
  FooterLinksContentWrapper,
  FooterLinksWrapper,
  FooterPaymentsWrapper,
  ImagesWrapper,
  LinkItem,
  LinkItems,
  LinksTitle,
  LogoImage,
  LogoWrapper,
  PaymentItem,
  SocialNetworkItemIcon,
  SocialNetworkItemLink,
  SocialNetworksWrapper
} from './footer.styles'

// Assets
import boleto from './assets/boleto.png'
import ssl from './assets/ssl.png'
import elo from './assets/elo.png'
import hipercard from './assets/hipercard.png'
import master from './assets/master.png'
import visa from './assets/visa.png'
import pix from './assets/pix.png'

export const Footer: FunctionComponent<FooterProps> = ({
  logoSrc,
  socialNetworks,
  bookletsLinks,
  ourClassesLinks,
  supportLinks
}) => {
  return (
    <Container>
      <ContentWrapper>
        <LogoWrapper>
          <LogoImage src={logoSrc} />

          <SocialNetworksWrapper>
            {socialNetworks.map((socialNetworkItem, index) => (
              <SocialNetworkItemLink
                key={`social-network-item-${index}`}
                href={socialNetworkItem.href}
                target="_blank"
              >
                <SocialNetworkItemIcon src={socialNetworkItem.iconSrc} />
              </SocialNetworkItemLink>
            ))}
          </SocialNetworksWrapper>
        </LogoWrapper>

        <FooterLinksWrapper>
          <FooterLinksContentWrapper>
            <LinksTitle>Nossas turmas</LinksTitle>

            <LinkItems>
              {ourClassesLinks.map((linkItem, index) => (
                <LinkItem
                  key={`our-classes-link-${index}`}
                  target="_blank"
                  href={linkItem.link}
                >
                  {linkItem.name}
                </LinkItem>
              ))}
            </LinkItems>
          </FooterLinksContentWrapper>

          <FooterLinksContentWrapper>
            <LinksTitle>Apostilas</LinksTitle>

            <LinkItems>
              {bookletsLinks.map((linkItem, index) => (
                <LinkItem
                  key={`booklet-link-${index}`}
                  target="_blank"
                  href={linkItem.link}
                >
                  {linkItem.name}
                </LinkItem>
              ))}
            </LinkItems>
          </FooterLinksContentWrapper>

          <FooterLinksContentWrapper>
            <LinkItems>
              {supportLinks.map((linkItem, index) => (
                <LinkItem
                  key={`support-link-${index}`}
                  target="_blank"
                  href={linkItem.link}
                >
                  {linkItem.name}
                </LinkItem>
              ))}
            </LinkItems>
          </FooterLinksContentWrapper>

          <FooterLinksContentWrapper>
            <ImagesWrapper>
              <PaymentItem src={ssl} />

              <LinksTitle>Formas de pagamento</LinksTitle>

              <FooterPaymentsWrapper>
                <PaymentItem src={boleto} />
                <PaymentItem src={elo} />
                <PaymentItem src={hipercard} />
                <PaymentItem src={master} />
                <PaymentItem src={pix} />
                <PaymentItem src={visa} />
              </FooterPaymentsWrapper>
            </ImagesWrapper>
          </FooterLinksContentWrapper>
        </FooterLinksWrapper>

        <AddressWrapper>
          PROSUCESSO EDUCACAO E TECNOLOGIA LTDA | CNPJ: 20.054.368/0001-40 |
          Endereço: Av. Almirante Júlio de Sa Bierrenbach, no 200, Jacarepaguá,
          CEP: 22.775-028 - Rio de Janeiro
        </AddressWrapper>
      </ContentWrapper>
    </Container>
  )
}
